import { Badge, Box, Flex, Text } from '@chakra-ui/react'

const Tag = ({ tags }) => {
  return (
    <Box mt='7'>
      <Text fontSize='23px'>Etiquetas</Text>
      <Flex my='5' flexWrap='wrap'>
        {tags.map((t, index) => (
          <Badge
            key={index}
            mr='3'
            mb='3'
            fontSize='12px'
          >
            {t.name}
          </Badge>
        ))}
      </Flex>
    </Box>
  )
}

export default Tag
